<template>
  <div class="invest container">
    <div class="row">
      <div class="col-lg-12">
        <loader v-show="isLoading"/>
        <div v-if="!isLoading" class="container">
          <stepper :steps="steps" @setstep="setStep"/>
          <div class="row">
            <div class="col-12 col-md-7 col-lg-7 col-xl-7">
              <div class="withdraw-form" v-if="enough_funds">
                <before-form-header class="header-table" :title="'views.withdraw.withdraw'"
                                    :description="'views.withdraw.withdrawDescription'"/>
                <div v-if="showInfo">
                  <b-alert show v-bind:variant="info.variant">
                    {{ info.message }}
                  </b-alert>
                </div>
                <b-form @submit="onSubmit" v-if="showForm">
                  <b-form-group>
                    <b-form-input
                        v-model="withdraw_form.amount"
                        v-bind:min="0.01"
                        v-bind:max="this.$store.state.investors.investor.investor_available_funds"
                        type="number" step="any"
                        required
                        :placeholder="$t('views.withdraw.withdrawalAmount')"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group>
                    <b-form-select
                        v-model="withdraw_form.investor_deposit_account"
                        :options="banks"
                        required
                        class="no-max-width"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>{{$t('views.withdraw.chooseYourBankAccount')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>

                  <b-button type="submit" variant="primary" class="withdraw-btn">{{ $t('views.withdraw.withdraw1') }}</b-button>
                </b-form>
              </div>
            </div>
            <div class="col-12" v-bind:class="enough_funds ? ' col-md-5 col-lg-5 col-xl-5 right-col ' : 'not-enough-section' ">
              <div v-bind:class="enough_funds ? '' : 'not-enough'">
                <info-block :step="infoStep" image="big-safe-box.svg" :title="infoTitle" :description="infoDescription"
                ></info-block>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeforeFormHeader from '../components/BeforeFormHeader'
import Loader from '../components/Loader'
import InfoBlock from '@/components/InfoBlock'
import investor from '../api/investor'
import Stepper from '../components/Stepper'
import loadingMixin from '@/mixins/loading'
import {investorStatuses} from '@/config/investorStatuses'

export default {
  components: {InfoBlock, Loader, BeforeFormHeader, Stepper},
  mixins: [loadingMixin],
  data()
  {
    return {
      isLoading: true,
      withdraw_form: {
        amount: '',
        investor_deposit_account: null
      },
      banks: [],
      showForm: true,
      showInfo: false,
      info: {
        variant: 'success',
        message: ''
      },
      infoStep: 0,
      infoTitle: '',
      infoDescription: '',
      step: 2,
      steps: [
        {id: 1, title: 'views.deposit.deposit', active: false, completed: false},
        {id: 2, title: 'views.deposit.withdraw', active: true, completed: false}
      ],
      enough_funds: false
    }
  },
  mounted()
  {
    this.isLoading = !this.loaded
  },
  computed: {},
  watch: {
    loaded: function ()
    {
      this.isLoading = !this.loaded
      if (this.loaded)
      {
        if (this.$store.state.investors.investor && this.$store.state.investors.investor.investor_account_status)
        {
          const accountStatus = this.$store.state.investors.investor.investor_account_status
          if (accountStatus !== investorStatuses.APPROVED && accountStatus !== investorStatuses.INVESTMENT_SUSPENDED && accountStatus !== investorStatuses.SUSPENDED) {
            this.$router.push('/account')
          }
        }
        this.enough_funds = (this.$store.state.investors.investor.investor_available_funds > 0)
        if (this.enough_funds)
        {
          this.infoStep = 6
          this.infoTitle = 'views.withdraw.bankTransfer'
          this.infoDescription = 'views.withdraw.pleaseNoteIban'
          this.isLoading = true
          investor.getAccountList().then(
              (response) =>
              {
                if (response)
                {
                  this.banks = [...this.banks, ...response]
                }
                this.isLoading = false
              }).catch(error =>
          {
            console.error(error)
            this.isLoading = false
          })
        }
        else
        {
          this.infoStep = 7
          this.infoTitle = 'views.withdraw.noFunds'
          this.infoDescription = 'views.withdraw.noFundsDescr'
        }
      }
    },
    step: function (number)
    {
      if (number === 1)
      {
        this.$router.history.push('/deposit')
      }
    }
  },
  methods: {
    setStep(number)
    {
      this.step = number
      // Fix for refresh form after success or error withdraw without refresh page
      if (number === 2 && this.showInfo) {
        this.withdraw_form.investor_deposit_account = this.withdraw_form.amount = null
        this.showInfo = false
        this.showForm = true
      }
    },
    onSubmit(evt)
    {
      evt.preventDefault()
      this.isLoading = true
      investor.setWithdraw(this.withdraw_form).then((response) =>
      {
        if (response)
        {
          this.showInfo = true
          this.showForm = false
          if (response.available_cash)
          {
            this.$store.state.investors.investor.investor_available_funds = parseFloat(response.available_cash)
          }
          else
          {
            console.error('Not found available cash parameter in response')
            this.$store.state.investors.investor.investor_available_funds -= parseFloat(this.withdraw_form.amount)
          }
          this.info.variant = 'success'
          this.info.message = this.$t('views.withdraw.successMsg')
        }
      })
          .catch((error) =>
          {
            this.showInfo = true
            this.info.variant = 'warning'
            this.info.message = error
            if (error.response && error.response.data && error.response.data.errorMessage) {
              this.info.message = error.response.data.errorMessage
            }
            console.error(error)
          }).then(() =>
      {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.custom-select{
  margin-left: 10px;
  min-height: 50px;
}

.withdraw-form {
  max-width: 520px;

  .withdraw-btn {
    float: right;
    margin-bottom: 20px;
  }
}

.right-col {
  max-width: 328px;
  //background: #FFFFFF;
  border-radius: 4px;
  min-height: 359px;
  text-align: center;

  h4 {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    font-feature-settings: 'liga' off;
    color: #000000;
  }

  img {
    padding-top: 5px
  }
}

.not-enough-section {
  text-align: center;

  .not-enough {
    max-width: 400px;
    display: inline-block;
    margin-top: 25px;
    margin-bottom: 25px;
  }
}

.no-max-width{
  max-width: none !important;
  margin: 0 !important;
}
</style>
